var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsChartData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_11389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.86667 17.3333L9.93333 13.2667L12.6 15.9333L17.3333 11.2333V13.3333H20V6.66667H13.3333V9.33333H15.4333L12.6 12.1667L9.93333 9.5L4 15.4667L5.86667 17.3333ZM2.66667 24C1.93334 24 1.30534 23.7387 0.782669 23.216C0.260002 22.6933 -0.000886625 22.0658 2.26372e-06 21.3333V2.66667C2.26372e-06 1.93334 0.261336 1.30534 0.784002 0.782669C1.30667 0.260002 1.93422 -0.000886625 2.66667 2.26372e-06H21.3333C22.0667 2.26372e-06 22.6947 0.261336 23.2173 0.784002C23.74 1.30667 24.0009 1.93422 24 2.66667V21.3333C24 22.0667 23.7387 22.6947 23.216 23.2173C22.6933 23.74 22.0658 24.0009 21.3333 24H2.66667Z",
    fill: "#003771"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_11389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsChartData);
export default __webpack_public_path__ + "static/media/material-symbols_chart-data.56dde777109af1d8d9f73f4c9f525412.svg";
export { ForwardRef as ReactComponent };